import React from 'react'

import Breadcrumbs from '../../components/common/Breadcrumbs/Breadcrumbs.tsx'
import Button from '../../components/common/Button/Button.tsx'
import Card from '../../components/common/Card/Card.tsx'
import Input from '../../components/common/forms/Input/Input.tsx'
import { useChangePasswordForm } from '../../hooks/useChangePasswordForm.ts'

const ChangePassword = () => {
  const { formik } = useChangePasswordForm()

  return (
    <>
      <Breadcrumbs
        pageName="Zmiana hasła"
        breadcrumbs={[
          { label: 'Strona główna', path: '/' },
          { label: 'Ustawienia', path: '/settings' },
          { label: 'Zmiana hasła' }
        ]}
      />

      <div className="max-w-150 mt-11">
        <Card>
          <Card.Body>
            <form onSubmit={formik.handleSubmit}>
              <Input
                id="oldPassword"
                name="oldPassword"
                type="password"
                placeholder="Stare hasło"
                formik={formik}
                className="max-w-[450px]"
              />

              <Input
                id="password"
                name="password"
                type="password"
                placeholder="Nowe hasło"
                formik={formik}
                className="max-w-[450px]"
              />

              <ul className="list-disc list-inside mt-4">
                <li>
                  Twoje hasło nie może być zbyt podobne do twoich innych danych
                  osobistych.
                </li>
                <li>Twoje hasło musi zawierać co najmniej 8 znaków.</li>
                <li>Twoje hasło nie może być powszechnie używanym hasłem.</li>
                <li>Twoje hasło nie może składać się tylko z cyfr.</li>
                <li>
                  Twoje hasło musi zawierać przynajmniej jedną wielką literę.
                </li>
                <li>Twoje hasło musi zawierać przynajmniej jedną cyfrę.</li>
                <li>
                  Twoje hasło musi zawierać przynajmniej jeden znak specjalny.
                </li>
              </ul>
              <Input
                id="passwordConfirmation"
                name="passwordConfirmation"
                type="password"
                placeholder="Nowe hasło (powtórz)"
                formik={formik}
                className="max-w-[450px] mt-4 !mb-0"
              />
              <p className="">
                Wprowadź to samo hasło ponownie, dla weryfikacji.
              </p>

              <Button
                variant="filled"
                size="medium"
                color="primary"
                type="submit"
                className="my-8"
                disabled={!formik.isValid || formik.isSubmitting}
              >
                {formik.isSubmitting ? 'Wysyłanie...' : 'Zmień hasło '}
              </Button>
            </form>
          </Card.Body>
        </Card>
      </div>
    </>
  )
}

export default ChangePassword
